import filetypes_document from './filetypes-document.svg';
import filetypes_drawing from './filetypes-drawing.svg';
import filetypes_excel from './filetypes-excel.svg';
import filetypes_folder from './filetypes-folder.svg';
import filetypes_folder_shared from './filetypes-folder-shared.svg';
import filetypes_form from './filetypes-form.svg';
import filetypes_fushion_table from './filetypes-fushion-table.svg';
import filetypes_image from './filetypes-image.svg';
import filetypes_ms_word from './filetypes-ms-word.svg';
import filetypes_pdf from './filetypes-pdf.svg';
import filetypes_power_point from './filetypes-power-point.svg';
import filetypes_presentation from './filetypes-presentation.svg';
import filetypes_script from './filetypes-script.svg';
import filetypes_site from './filetypes-site.svg';
import filetypes_spreadsheet from './filetypes-spreadsheet.svg';
import filetypes_video from './filetypes-video.svg';

export const V2_FILE_TYPES_ICONS: { [char: string]: string } = {
  filetypes_document,
  filetypes_drawing,
  filetypes_excel,
  filetypes_folder,
  filetypes_folder_shared,
  filetypes_form,
  filetypes_fushion_table,
  filetypes_image,
  filetypes_ms_word,
  filetypes_pdf,
  filetypes_power_point,
  filetypes_presentation,
  filetypes_script,
  filetypes_site,
  filetypes_spreadsheet,
  filetypes_video,
};

export const V2_FILE_TYPES_ICON_NAMES: string[] = Object.keys(V2_FILE_TYPES_ICONS);
